import { FC, FocusEvent, MouseEvent, TouchEvent, memo, useCallback } from "react";
import { ClearIndicatorProps } from "react-select";

import { Button } from "capitalrx-components-2.0/lib/general";
import classNames from "classnames";

import { CustomReactSelectProps } from "../../CustomReactSelectProps";
import { OptionItem } from "../../OptionItem";

import styles from "../../styles.module.css";

/**
 * The clear indicator component.
 */
export const ClearIndicator: FC<ClearIndicatorProps<OptionItem | null>> = memo((props) => {
  const { setValue, selectProps } = props;

  const clickHandler = useCallback(() => {
    setValue(null, "deselect-option");
  }, [setValue]);

  const focusHandler = useCallback((ev: FocusEvent) => {
    ev.preventDefault();
    ev.stopPropagation();
  }, []);

  const mouseDownHandler = useCallback((ev: MouseEvent) => {
    ev.preventDefault();
    ev.stopPropagation();
  }, []);

  const touchStartHandler = useCallback(
    (ev: TouchEvent<HTMLDivElement>) => {
      ev.stopPropagation();
      setValue(null, "deselect-option");
    },
    [setValue],
  );

  if ((selectProps as CustomReactSelectProps).isReadOnly) return null;

  return (
    <div onFocus={focusHandler} onMouseDown={mouseDownHandler} onTouchStart={touchStartHandler}>
      <Button
        tabIndex={-1}
        className={classNames(styles.Clear, "clear")}
        icon="x"
        size="small"
        appearance="text"
        tooltip="Clear value"
        onClick={clickHandler}
        aria-label="Clear selected value"
      />
    </div>
  );
});
